import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	QueryList,
	SimpleChanges,
	ViewChild
} from '@angular/core';

import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';
import { ModalService } from '../../../../shared/directives/modal/modal.service';
import { CreativePerformance } from '../../creative-detail-v2/creative-detail.interface';

@Component({
	selector: 'app-creative-performance-stats',
	styleUrls: ['./creative-performance-stats.component.css'],
	templateUrl: './creative-performance-stats.component.html'
})
export class CreativePerformanceStatsComponent implements OnInit {
	@Input() creative: CreativePerformance;
	@Input() creativeIndex: number;
	@Input() showStats;
	// tslint:disable-next-line: prefer-output-readonly
	@Output() previewCreativeEvent = new EventEmitter<number>();
	@Input() dateRange: string;
	@Input() sectionclass: any;
	@Input() producttype: string;
	@ViewChild('networkLogo') el: ElementRef;
	public partnerName: string;
	public creativePlaceholder: string = '/assets/images/no-display-creative.png';
	public allowTelevisionCreative: boolean = false;
	public isOverviewPrerollGAM: boolean = false;
	public isDOOH: boolean = false;

	constructor(public analyticsDataModel: AnalyticsDataModel) {}
	ngOnChanges(changes: SimpleChanges): void {
		setTimeout(() => {
			this.checkFontSize();
		}, 0);
	}
	checkFontSize(): void {
		const elems = document.querySelectorAll('#networkLogo');

		// tslint:disable-next-line: prefer-for-of
		for (let i = 0; i < elems.length; i++) {
			this.reduceFontSize(elems[i]);
		}
	}
	reduceFontSize(element: any): void {
		if (element.scrollWidth > element.clientWidth) {
			const fontSize = parseInt(element.style.fontSize, 10) - 1;
			if (fontSize > 1) {
				element.style.fontSize = fontSize + 'px';
				this.reduceFontSize(element);
			}
		}
	}

	ngOnInit(): void {
		this.creative = this.creative ? this.creative : ({} as CreativePerformance);
		this.allowTelevisionCreative = this.analyticsDataModel.config.directoryName.includes('r102') ? true : false;
		if (this.creative.creativeThumbnail == 'null' || this.creative.creativeThumbnail == null) {
			this.creative.creativeThumbnail = this.creativePlaceholder;
		}
		this.partnerName = this.analyticsDataModel.partner.partnerName;
		this.isOverviewPrerollGAM = this.producttype.includes('gam_preroll');
		this.isDOOH = this.producttype.toLocaleLowerCase().includes('dooh');
	}
	isTypeString(description: any): boolean {
		return typeof description === 'string';
	}
	openModal(): void {
		this.previewCreativeEvent.emit(this.creativeIndex);
	}

	getCreativeSize(thumbnail: string): string {
		if (
			thumbnail.includes('728x90') ||
			thumbnail.includes('468x60') ||
			thumbnail.includes('320x50') ||
			thumbnail.includes('300x50')
		) {
			return '100% 30%';
		} else if (thumbnail.includes('300x600')) {
			return '75% 100%';
		} else if (thumbnail.includes('160x600')) {
			return '40% 100%';
		} else {
			return '100% 100%';
		}
	}
}
